import React, { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import { FontSize } from "../utils/types";
import { fontSizeMapping } from "../utils/mappings";

/** "hairline" matches the Vendor List cards: 1px neutral border, 12px radius, 1px/2px shadow. */
export type PanelVariant = "default" | "hairline";

export function EmptyPanel({
  widthClass = "w-[830px]",
  variant = "default",
  children,
}: {
  widthClass?: string;
  variant?: PanelVariant;
  children?: React.ReactNode;
}) {
  return (
    <div className="tw-boundary">
      <div
        className={
          variant === "hairline"
            ? `${HAIRLINE_CARD} p-6 ${widthClass}`
            : `rounded-[10px] p-6 ${widthClass}`
        }
        style={
          variant === "hairline" ? undefined : { boxShadow: "0px 2px 12px 0px rgba(0, 0, 0, 0.12)" }
        }
      >
        {children}
      </div>
    </div>
  );
}

export const HAIRLINE_CARD =
  "bg-white border border-solid border-neutral-200 rounded-xl shadow-[0px_1px_2px_0px_#1018280D]";

export function ExpandablePanel({
  title,
  titleFontSize,
  children,
  widthClass = "w-[830px]",
  variant = "default",
}: {
  title: string;
  titleFontSize: FontSize;
  children?: React.ReactNode;
  widthClass?: string;
  variant?: PanelVariant;
}) {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <EmptyPanel widthClass={widthClass} variant={variant}>
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <div
            className={
              variant === "hairline"
                ? "text-[16px] leading-[24px] font-semibold text-neutral-900"
                : `font-bold ${fontSizeMapping[titleFontSize]} text-neutral-900`
            }
          >
            {title}
          </div>
        </div>
        <div onClick={() => setIsExpanded(!isExpanded)} className="cursor-pointer">
          {isExpanded ? (
            <ChevronUpIcon
              className={variant === "hairline" ? "h-5 w-5 text-neutral-700" : "h-6 w-6"}
            />
          ) : (
            <ChevronDownIcon
              className={variant === "hairline" ? "h-5 w-5 text-neutral-700" : "h-6 w-6"}
            />
          )}
        </div>
      </div>
      {isExpanded && children}
    </EmptyPanel>
  );
}
